import logo from "#assets/logo.svg";
import logoOrange from "#assets/logo-orange.svg";

export const LogoVariant = {
	white: logo,
	orange: logoOrange,
};
type LogoVariantKey = keyof typeof LogoVariant;

export default function SpinningLogo({
	variant = "white",
	className,
}: {
	variant?: LogoVariantKey;
	className?: string;
}) {
	return (
		<img
			src={LogoVariant[variant]}
			alt="Stringiverse Logo"
			className={`h-auto will-change-transform animate-[logo-spin-bounce_8s_cubic-bezier(.34,1.56,.64,1)_infinite] reduce-motion:animate-none ${className}`}
		/>
	);
}
